/**
 * The back office lives outside any organization (`/:orgId?/-`), so its routes are declared in
 * `OperondaApp` and guarded by the platform claim, not by `ALLOWED_ROLES`.
 */
export const BACKOFFICE_BASE_PATH = '/backoffice';

export const PATHS = {
  ACCOUNTS: BACKOFFICE_BASE_PATH,
  ACCOUNT_DETAIL: `${BACKOFFICE_BASE_PATH}/accounts/:accountId`,
} as const;

export const AUDIT_PAGE_SIZE = 20;

/** The accounts list loads every account and pages them in the browser. */
export const ACCOUNTS_LIST_PAGE_SIZE = 50;

export const ACCOUNTS_LIST_VIEW_STORAGE_KEY = 'backofficeAccountsList';

/** Same bounds as `reasonInput` in services: every back-office change is audited with it. */
export const REASON_MIN_LENGTH = 3;
export const REASON_MAX_LENGTH = 500;

/** Same bound as `planInput.code` in services. */
export const PLAN_CODE_MAX_LENGTH = 100;

/** ISO 4217 codes offered for a plan price. CLF is the Chilean UF (Unidad de Fomento). */
export const PLAN_CURRENCIES = ['CLP', 'CLF', 'USD', 'ARS'] as const;

export type PlanCurrency = (typeof PLAN_CURRENCIES)[number];
